import clsx from 'clsx';
import dayjs from 'common/dayjs.ts';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { LanguageInfo, SupportedLanguages } from '#admin/i18n.ts';
import { HeaderMenu } from './HeaderMenu.tsx';

export const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng: string) => () => {
    void i18n.changeLanguage(lng);
    document.documentElement.lang = lng;
  };

  const selectedLangugage = LanguageInfo[i18n.language];

  useEffect(() => {
    dayjs.locale(i18n.language);
  }, [i18n.language]);

  return (
    <HeaderMenu title={selectedLangugage.flag} justify={'right'}>
      {SupportedLanguages.map((lang) => (
        <button
          key={lang}
          onClick={changeLanguage(lang)}
          className={clsx('px-3 py-1 text-left font-medium text-sm', i18n.language === lang ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300')}
        >
          {LanguageInfo[lang].flag} {LanguageInfo[lang].name}
        </button>
      ))}
    </HeaderMenu>
  );
};
